//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex';

// const DEFAULT_SIDEBAR_DESCRIPTION = 'Browse popular and latest royalty-free assets in this category.';
const DEFAULT_SIDEBAR_DESCRIPTION = '';

export default {
  name: 'LandingCategoryHeroAside',
  props: {
    mediaType: { type: String, default: null },
    categoryId: { type: String, default: null },
  },
  computed: {
    ...mapState({
      currentCategory: state => state.category.categoryData,
    }),
    ...mapGetters({
      latest: 'category/latest',
      popular: 'category/popular',
    }),
    categoryName() {
      return this.$store.getters['category/title'] || _.get(this.currentCategory, 'html.title', '') || _.get(this.currentCategory, 'name', '');
    },
    sidebarDescription() {
      const desc = this.$store.getters['category/description'] || _.get(this.currentCategory, 'html.description', '') || _.get(this.currentCategory, 'description', '');
      return desc || DEFAULT_SIDEBAR_DESCRIPTION;
    },
    sidebarDescriptionNl2br() {
      const desc = this.sidebarDescription;
      if (!desc) return '';
      return _.escape(desc).replace(/\r?\n/g, '<br>');
    },
  },
};
